import { defineComponent as _defineComponent } from 'vue'
import { computed } from '../../../../../adapter-vue';
import Icon from '../../../../common/Icon.vue';
import playIcon from '../../../../../assets/icon/video-play.png';
import { IVideoMessageContent } from '../../../../../interface';
interface IProps {
  messageContent: Record<string, unknown> | IVideoMessageContent | undefined;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'message-abstract-video',
  props: {
    messageContent: { default: () => ({}) as IVideoMessageContent }
  },
  setup(__props: any) {

const props = __props as { messageContent: Record<string, unknown> | IVideoMessageContent | undefined }


const videoUrl = computed<string>(() => {
  return (props.messageContent as IVideoMessageContent).snapshotUrl || (props.messageContent as IVideoMessageContent).url;
});

return { __sfc: true,props, videoUrl, Icon, playIcon }
}

})